class InputCopyLink {
    constructor(element, config = {}) {
        this.element = element;
        this.groupCopyLink = (this.element) ? this.element.nextElementSibling : null;
        this.clicked = false;
        this.config = {
            copyTimeout: config.copyTimeout || 1500,
            copiedText: config.copiedText || 'Disalin!'
        };
        this.init();
    }

    attachListeners() {
        if (this.groupCopyLink) {
            this.groupCopyLink.addEventListener('click', () => {
                if (this.clicked) return;
                this.clicked = true;
                const tempBsTitle = this.groupCopyLink.getAttribute('data-bs-title');
                const copyText = this.element.value;
                if (navigator.clipboard && navigator.clipboard.writeText) {
                    navigator.clipboard.writeText(copyText).then(() => {
                        this.element.select();
                        this.element.classList.add('form-control-copied');
                        if (bootstrap) {
                            const tooltip = bootstrap.Tooltip.getOrCreateInstance(this.groupCopyLink);
                            tooltip._config.title = this.config.copiedText;
                            tooltip.show();
                        }
                        setTimeout(() => {
                            this.clicked = false;
                            this.element.classList.remove('form-control-copied');
                            if (bootstrap) {
                                const tooltip = bootstrap.Tooltip.getOrCreateInstance(this.groupCopyLink);
                                tooltip._config.title = tempBsTitle;
                                tooltip.hide();
                            }
                        }, this.config.copyTimeout);
                    }).catch(err => {
                        console.error('Error copying text: ', err);
                    });
                } else {
                    const tempTextarea = document.createElement('textarea');
                    tempTextarea.style.display = 'none';
                    tempTextarea.value = copyText;
                    document.body.appendChild(tempTextarea);
                    tempTextarea.select();
                    try {
                        document.execCommand('copy');
                        this.element.classList.add('form-control-copied');
                        if (bootstrap) {
                            const tooltip = bootstrap.Tooltip.getOrCreateInstance(this.groupCopyLink);
                            tooltip._config.title = this.config.copiedText;
                            tooltip.show();
                        }
                        setTimeout(() => {
                            this.clicked = false;
                            this.element.classList.remove('form-control-copied');
                            if (bootstrap) {
                                const tooltip = bootstrap.Tooltip.getOrCreateInstance(this.groupCopyLink);
                                tooltip._config.title = tempBsTitle;
                                tooltip.hide();
                            }
                        }, this.config.copyTimeout);
                    } catch (err) {
                        console.error('Fallback: Error copying text: ', err);
                    }
                    document.body.removeChild(tempTextarea);
                }
            });
        }
    }

    value() {
        return this.element.value;
    }

    val() {
        return this.value();
    }

    init() {
        this.attachListeners();
    }
}

// Inisialisasi class setelah DOM siap
document.addEventListener('DOMContentLoaded', () => {
    new InputCopyLink();
});

export default InputCopyLink;